/**
 * Created by BaiDX on 17/6/9.
 */
const global = {};

global.sheets={};
let origin = '';
if(window.location.hostname=='localhost'){//a
  origin = 'http://analyze.msgcopy.com'
}else{
  origin = ''
}
if(window.location.hostname.indexOf('msgcopy.com')>0||window.location.hostname=='localhost'||window.location.hostname.indexOf('maprca-dev')>=0){
  global._PROJECT = '';
}else{
  global._PROJECT = 'shdq';
}
if(window.location.hostname.indexOf('shanghai-electric')>=0&&window.location.hostname.indexOf('maprca-dev')<0){
  global._PROJECT = 'shdq'
}else{
  global._PROJECT = '';
}
global.domain = {
  editor:origin+'/editor',
  diy:origin+'/diy',
  bi:origin+'/bi',
  test:origin+'/test',
  www:origin+'/www',
};
global.api = {
  analyze: origin
};
export default global;



// WEBPACK FOOTER //
// ./src/global.js